module.exports = __webpack_public_path__ + "static/img/cont50 (3).3bcb3b1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news/cont50 (3).jpg
// module id = 1ORt
// module chunks = 0